import store from '@sb/store'
import sb from '@sb/util'
const browser = require('bowser').getParser(window.navigator.userAgent).parsedResult
import controller from './views/controller.js'
import Vue from 'vue'
import TEMPLATE from '@subiz/campaign-template'

// returns [type, value]
function resolveCondition (cond) {
	if (cond.key.startsWith('utm_')) return ['string', sb.getUrlParameter(window.location.href, cond.key)]
	if (cond.key === 'time_on_page') return ['number', timeOnPage]
	if (cond.key === 'referrer') return ['string', document.referrer]
	if (cond.key === 'language') return ['string', navigator.language]
	if (cond.key === 'device_type') {
		let type = 'desktop'
		if (browser.platform.type === 'mobile') type = 'mobile'
		if (browser.platform.type === 'tablet') type = 'tablet'
		return ['string', type]
	}
	if (cond.key === 'browser') return ['string', browser.browser.name]
	if (cond.key === 'os') return ['string', browser.os.name]
	if (cond.key === 'source') {
		return ['string', sb.getSourceFromRef(sb.getUrlParameter(document.referrer, 'gclid'), document.referrer)]
	}
	if (cond.key === 'source_referrer') return ['string', document.referrer]
	if (cond.key === 'country_code') return ['string', sb.get(store, 'loc.country_code', '')]
	if (cond.key === 'city') return ['string', sb.get(store, 'loc.city', '')]
	if (cond.key === 'returning_visitor') return ['bool', !store.new_visitor, false]
	if (cond.key === 'new_visitor') return ['bool', store.new_visitor, false]
	if (cond.key === 'current_url') return ['string', window.location.href]
	if (cond.key === 'url') return ['string', window.location.href]
	return ['string', '']
}

// returns true or false
function checkCondition (cond) {
	if (!cond) return true
	if (!cond.key) return true

	// not support
	if (
		cond.key === 'has_visited_urls' ||
		cond.key === 'has_not_visited_urls' ||
		cond.key === 'page_view_count' ||
		cond.key === 'ip_ranges'
	) {
		return false
	}

	let [type, lval] = resolveCondition(cond)
	let op = cond.operator || 'eq'
	let rval = cond.value ? sb.parse(cond.value) : ''
	return sb.evaluate(type, lval, op, rval)
}

window.sbz_checkCondition = checkCondition
window.sbz_check = check

// server doesn't return limited campaigns of user,
// so client doesn't need care about impression limit
function check (camp) {
	let match = true

	let schedulers = sb.get(camp, 'schedulers') || []
	let anyValid = false
	for (let s of schedulers) {
		let currentTzInMin = -1 * new Date().getTimezoneOffset()
		let tzInMin = currentTzInMin
		if (sb.get(s, 'timezone_offset')) {
			tzInMin = sb.offsetToMin(sb.get(s, 'timezone_offset'))
		}

		let now = new Date(new Date().getTime() + (tzInMin - currentTzInMin) * 60 * 1000)
		let nowInMinute = now.getHours() * 60 + now.getMinutes()

		let startTime = sb.getMs(sb.get(s, 'start_time', 0)) || 0
		if (startTime > 0 && startTime > new Date().getTime()) continue
		let endTime = sb.getMs(sb.get(s, 'end_time', 0)) || 0
		if (endTime > 0 && endTime < new Date().getTime()) continue

		if (s.days_of_week !== undefined) {
			let days = sb.norm(s.days_of_week)
			let dayName = sb.norm(sb.getDayName(now.getDay()))
			if (!days.includes(dayName)) continue
		}

		if (s.start_minute_day !== undefined && s.start_minute_day > nowInMinute) continue
		if (s.end_minute_day !== undefined && s.end_minute_day < nowInMinute) continue

		anyValid = true
		break
	}
	if (schedulers.length > 0 && !anyValid) return false

	let segs = sb.get(camp, 'segmentations') || []
	let sjoin = sb.get(camp, 'segmentation_join') || 'and'

	// if and, default match is true, if any false, match is false
	// if or, default match is false, if any true, match is true
	match = sjoin === 'and'

	for (let seg of segs) {
		let conds = sb.get(seg, 'conditions') || []
		let srcConds = sb.get(seg, 'source_conditions') || []
		let locConds = sb.get(seg, 'location_conditions') || []
		let urlConds = sb.get(seg, 'url_conditions') || []

		// skip empty conds
		if (conds.length === 0 && srcConds.length === 0 && locConds.length === 0 && urlConds.length === 0) continue

		let join = sb.get(seg, 'join') || 'and'
		let smatch = join === 'and'

		let conMatch = join === 'and'
		for (let c of conds) {
			let cmatch = checkCondition(c)
			if (join === 'and' && !cmatch) {
				conMatch = false
				break
			}
			if (join === 'or' && cmatch) {
				conMatch = true
				break
			}
		}
		if (conds.length > 0 && join === 'and' && !conMatch) smatch = false
		if (conds.length > 0 && join === 'or' && conMatch) smatch = true

		let srcMatch = false
		for (let c of srcConds) {
			let cmatch = checkCondition(c)
			if (cmatch) {
				srcMatch = true
				break
			}
		}
		if (srcConds.length > 0 && join === 'and' && !srcMatch) smatch = false
		if (srcConds.length > 0 && join === 'or' && srcMatch) smatch = true

		let locMatch = false
		for (let c of locConds) {
			let cmatch = checkCondition(c)
			if (cmatch) {
				locMatch = true
				break
			}
		}
		if (locConds.length > 0 && join === 'and' && !locMatch) smatch = false
		if (locConds.length > 0 && join === 'or' && locMatch) smatch = true

		let urlMatch = false
		for (let c of urlConds) {
			let cmatch = checkCondition(c)
			if (cmatch) {
				urlMatch = true
				break
			}
		}
		if (urlConds.length > 0 && join === 'and' && !urlMatch) smatch = false
		if (urlConds.length > 0 && join === 'or' && urlMatch) smatch = true

		let exMatch = false
		let exUrlConds = sb.get(seg, 'exclude_url_conditions') || []
		for (let c of exUrlConds) {
			let cmatch = checkCondition(c)
			if (cmatch) {
				excludeMatch = true
				break
			}
		}
		if (exUrlConds.length > 0 && join === 'and' && exMatch) smatch = false
		if (exUrlConds.length > 0 && join === 'or' && !exMatch) smatch = true

		if (sjoin === 'and' && !smatch) {
			match = false
			break
		}
		if (sjoin === 'or' && smatch) {
			match = true
			break
		}
	}
	if (segs.length > 0 && !match) return false

	return true
}

// track time on page
let timeOnPage = 0 // seconds
setInterval(() => {
	timeOnPage++
}, 1000)

function Campaign (camp) {
	let pageIndex = 0
	let pageVue
	let triggerType
	let impressionToken

	let campDiv
	function getCampaignDiv () {
		if (campDiv) return campDiv
		campDiv = document.createElement('div')
		campDiv.id = 'sbz-pop'
		campDiv.className = 'campaign subiz-campaign-' + camp.id
		document.body.appendChild(campDiv)
		return campDiv
	}

	function handleButtonClick (button, page) {
		let actions = sb.get(button, 'actions') || []
		var hasConversion = false

		for (let a of actions) {
			if (a.action === 'open_widget') controller.showWidget('list')
			if (a.action === 'submit' || a.action === 'conversation') {
				hasConversion = true
			}

			if (a.action === 'conversion') {
				hasConversion = true
			}

			if (a.action === 'goal_reach') {
				store.setGoalReached(camp.id)
				hasConversion = true
			}
		}

		if (hasConversion) {
			let submission = {
				account_id: sb.get(store, 'user.account_id'),
				campaign_id: sb.get(camp, 'id'),
				user_id: sb.get(store, 'user.id'),
				fields: sb.get(pageVue.$props, 'page.form.fields') || [],
			}
			store.sendConversion(camp.id, triggerType, submission, impressionToken)

			// update user info
			let user = sb.cloneDeep(store.user)
			sb.map(sb.get(pageVue.$props, 'page.form.fields'), field => {
				sb.setUserAttr(user, { key: field.key, [field.type]: JSON.parse(field.value) })
			})
			store.setUser(user)
		}

		for (let a of actions) {
			if (a.action === 'close') onCloseButtonClick()

			if (a.action === 'next_page') {
				pageIndex++
				let p = sb.get(camp, `pages.${pageIndex}`) || {}
				showPage(p)
			}
		}

		for (let a of actions) {
			if (a.action === 'open_url' && a.new_tab) {
				onCloseButtonClick()
				window.open(a.url, '_blank')
				return
			}

			if (a.action === 'open_url' && !a.new_tab) {
				window.location.href = a.url
				return
			}
		}
	}

	function onPrimaryClick () {
		let page = sb.get(camp, `pages.${pageIndex}`)
		let button = sb.get(camp, `pages.${pageIndex}.primary_button`)
		if (!button) return
		handleButtonClick(button, page)
	}

	function onSecondaryClick () {
		let page = sb.get(camp, `pages.${pageIndex}`)
		let button = sb.get(camp, `pages.${pageIndex}.secondary_button`)
		if (!button) return
		handleButtonClick(button, page)
	}

	function onBackgroundClick () {
		let page = sb.get(camp, `pages.${pageIndex}`)
		let button = sb.get(camp, `pages.${pageIndex}.background_click`)
		if (!button) return
		handleButtonClick(button, page)
	}

	function onCloseButtonClick () {
		//let campDiv = getCampaignDiv()
		//campDiv.innerHTML = ''
		// if (pageVue) pageVue.$destroy()
	}

	async function showPage (page) {
		let templateId = pageIndex < 1 ? sb.get(camp, 'template_id') : 'templateThanks'
		let campDiv = getCampaignDiv()

		let userAttributes = sb.get(store.user, 'attributes')
		let fields = sb.get(page, 'form.fields', [])
		sb.each(fields, field => {
			sb.map(userAttributes, attr => {
				if (field.key !== attr.key) return
				field.value = JSON.stringify(attr[field.type])
			})
		})

		let Template = Vue.extend(TEMPLATE.Template)
		if (pageVue) pageVue.$destroy()
		pageVue = new Template({ propsData: { page, template: templateId } })
		pageVue.$on('closeButtonClicked', onCloseButtonClick)
		pageVue.$on('primaryButtonClicked', onPrimaryClick)
		pageVue.$on('secondaryButtonClicked', onSecondaryClick)
		pageVue.$on('backgroundClicked', onBackgroundClick)

		campDiv.innerHTML = '' // reset

		let div = document.createElement('div')
		div.className = 'campaign-page-' + pageIndex
		campDiv.appendChild(div)
		pageVue.$mount(`.subiz-campaign-${camp.id} .campaign-page-${pageIndex}`)
	}

	// prevent run multiple times
	let ran = false

	async function run (byTrigger) {
		if (ran) return
		ran = true
		let match = check(camp)
		if (!match) return

		console.log('[SBZ] CAMPAIGN RUN BY', byTrigger)

		pageIndex = 0
		let page = sb.get(camp, `pages.${pageIndex}`) || {}
		showPage(page)

		triggerType = byTrigger
		let impression = await store.sendImpression(camp.id, byTrigger)
		impressionToken = sb.get(impression, 'impression_token') || ''
	}

	this.init = () => {
		let triggers = sb.get(camp, 'triggers') || []
		for (let tr of triggers) {
			let cb = run.bind(this, tr.type)
			if (tr.type === 'exit_intent') sb.trackExitIntent(cb)
			if (tr.type === 'area_clicked') sb.trackAreaClicked(tr.area_clicked_css_selector, cb)
			if (tr.type === 'scrolling_percentage') sb.trackScrollingPercentage(tr.scrolling_percentage, cb)
			if (tr.type === 'inactivity_duration') sb.trackInactivity(tr.inactivity_sec, cb)
			if (tr.type === 'after_pageview') sb.trackTimeOnPage(tr.after_pageview_sec, cb)
		}
	}
}

async function init () {
	let campM = sb.get(store, 'campaignM') || {}
	if (Object.keys(campM).length === 0) return

	await store.fetchLocation()

	sb.each(campM, c => {
		new Campaign(c).init()
	})
}

export default init
